import ROOMTYPES from './roomTypes';

export default class RoomTypeFactory {
  static createInstance(type) {
    const roomTypeCreator = ROOMTYPES[type];
    const roomType = roomTypeCreator ? new roomTypeCreator() : null;

    return roomType;
  }
}
